import { useTranslation } from "react-i18next";
import { RingGauge } from "../../components/neu/RingGauge";
import { NeuButton, NeuCard } from "../../components/neu/Neu";

const KEYS = ["attendance", "punctuality", "duties", "absence", "tasks"];

// بطاقة تفصيل أداء موظف واحد: العدّاد + المركّبات الموزونة + خصم العقوبات.
export const KpiDetail = ({ row, onClose }) => {
  const { t } = useTranslation();
  if (!row) return null;
  return (
    <NeuCard className="grid gap-4" data-testid="kpi-detail">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-base font-black">{row.employee_name}</p>
          <p className="text-xs text-muted-foreground">{row.job_title || "—"} · {row.month}</p>
        </div>
        {onClose ? (
          <NeuButton className="px-3 py-2 text-xs" data-testid="kpi-detail-close" onClick={onClose}>
            {t("common.close")}
          </NeuButton>
        ) : null}
      </div>

      <div className="flex flex-wrap items-center gap-6">
        <div className="scale-[0.85]">
          <RingGauge value={row.score} total={100} label={t("kpi.score")} tone="#6cc24a" testId="kpi-gauge" />
        </div>
        <div className="grid flex-1 gap-2">
          {KEYS.map((key) => (
            <div key={key} className="grid gap-1" data-testid={`kpi-part-${key}`}>
              <div className="flex items-center justify-between text-xs">
                <span className="font-bold">{t(`kpi.parts.${key}`)}</span>
                <span className="num text-muted-foreground">
                  {row.components[key]} · {t("kpi.weight")} {row.weights[key]}%
                </span>
              </div>
              <div className="h-2 w-full rounded-full bg-muted shadow-neu-in">
                <div className="h-2 rounded-full bg-primary" style={{ width: `${row.components[key]}%` }} />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-wrap gap-2 text-xs">
        <span className="rounded-full bg-primary/10 px-3 py-1 font-bold text-primary">
          {t("kpi.baseScore")}: <span className="num">{row.base_score}</span>
        </span>
        <span className="rounded-full bg-destructive/10 px-3 py-1 font-bold text-destructive"
              data-testid="kpi-penalty-deduction">
          {t("kpi.penaltyDeduction")}: <span className="num">-{row.penalty_deduction}</span>
          {" "}({t("kpi.penaltyCount", { count: row.penalty_count })}, {t("kpi.cap")} {row.penalty_cap})
        </span>
      </div>
    </NeuCard>
  );
};
